<script>
import toHTML from 'linkifyjs/html';

import { SectionPostTypes } from '../../constants';

export default {
  name: 'CpSocialFeedBlogPost',
  data() {
    return {
      showLikesModal: false,
      comments_count: this.blog.comments_count,
      type: SectionPostTypes.BLOGS,
    };
  },
  directives: {
    margin: require('../../directives/margins').margin,
    marginBottom: require('../../directives/margins').marginBottom,
    marginTop: require('../../directives/margins').marginTop,
  },
  components: {
    PersonIcon: require('../icons').default,
    CpBaseSvgIcon: require('../../base-svg-icon').default,
    CpButtonLink: require('../../button-link').default,
    CpImage: require('../../image').default,
    CpSocialShareDialog: require('../../dialogs/social-share').default,
    LikeActionButton: require('../actions/like-action-button').default,
    CpLikesProfiles: require('../../likes/likes-profiles').default,
    CpDialog: require('../../dialog').default,
    CommentActionButton: require('../actions/comment-action-button').default,
    CpCommentsPost: require('../../comments/box-comments').default,
    CpGrid: require('../../grid').default,
    CpGridItem: require('../../grid-item').default,
    CpDialogAuthForm: require('../../auth-form/dialog-auth-form').default,
    CpCardHeaderReactions: require('../../components/CardHeaderReactions').default,
    CpShowInteractionsCount: require('../../components/ShowInteractionsCount').default,
    CpShowImageInCard: require('../../components/ShowImageInCard').default,
    CpTruncateText: require('../../components/TruncateText').default,
  },
  props: {
    blog: { type: Object, default: () => {} },
    explore: Boolean,
    forShare: Boolean,
  },
  methods: {
    profile(slug) {
      return '/profile/' + slug;
    },
    blogDetails(id) {
      return '/blogs/' + id;
    },
    handleLikesModal() {
      this.showLikesModal = !this.showLikesModal;
    },
    handleCountLikes(value) {
      value ? (this.blog.likes_count = this.blog.likes_count + 1) : (this.blog.likes_count = this.blog.likes_count - 1);
    },
    setCommentsCount(action) {
      action == 'remove' ? this.comments_count-- : this.comments_count++;
    },
  },
  computed: {
    content() {
      return toHTML(this.blog.description);
    },
    authUser() {
      return this.$root.authUser;
    },
  },
};
</script>

<template>
  <div class="social-feed-post-wrapper">
    <!-- TO DO: uncomment this when we implement the new feed logic -->
    <!-- <div v-if="explore && blog.last_activity && !forShare" style="display: flex">
      <CpCardHeaderReactions :post="blog.last_activity" />
    </div>
    <hr v-if="explore && blog.last_activity && !forShare" class="search-results__tick_action" /> -->

    <div class="social-feed-post-profile-wrapper">
      <div>
        <a class="profile-img social-feed-default-img" :href="profile(blog.owner.slug)">
          <cp-image
            class="user-image"
            :src="blog.owner.profile_image"
            circular
            :width="$root.isMobile ? '38' : '50'"
            :height="$root.isMobile ? '38' : '50'"
          ></cp-image>
        </a>
      </div>
      <span class="mini-recipient">
        <span>
          <a :href="profile(blog.owner.slug)" class="profile-name heading-4">{{ blog.owner.name }}</a>
        </span>
      </span>
    </div>
    <a :href="blogDetails(blog.id)" style="cursor: pointer; text-decoration: none">
      <p class="title">{{ blog.name }}</p>
    </a>
    <CpTruncateText :content="blog.description" />
    <a :href="blogDetails(blog.id)" style="cursor: pointer; text-decoration: none">
      <CpShowImageInCard v-if="blog.image" :image="blog.image" :link="blogDetails(blog.id)" v-margin-bottom="1" />
    </a>
    <div class="social-feed-post-profile-wrapper" v-if="blog.video">
      <video controls preload="metadata" class="video">
        <source :src="blog.video" type="video/mp4" />
      </video>
    </div>

    <div v-if="!forShare" style="margin-top: 10px !important">
      <CpShowInteractionsCount :type="type" :id="blog.id" :likesCount="blog.likes_count" :commentsCount="comments_count" :handleLikesModal="handleLikesModal" />
    </div>

    <cp-dialog v-if="showLikesModal && !forShare">
      <cp-likes-profiles :count-likes="blog.likes_count" :id="parseInt(blog.id)" :type="'blogs'" @close="handleLikesModal"> </cp-likes-profiles>
    </cp-dialog>

    <div v-if="!forShare" class="social-feed-post-actions">
      <div class="post-action-button like">
        <like-action-button type="blogs" :id="blog.id" :liked="blog.liked" :onSuccess="handleCountLikes" />
      </div>
      <div class="post-action-button comment">
        <comment-action-button :type="type" :id="blog.id" />
      </div>
      <div class="post-action-button share">
        <cp-social-share-dialog
          class="feed"
          :allow-share-feed="true"
          :type="'blogs'"
          :post="blog"
          share-category="Blog"
          share-button-class="button--noborder"
          :url="blog.permalink"
          :explore="explore"
          title="Blog found via CrowdBlue - Social Network For Politics"
          :description="`Wanted to share this blog article I found on CrowdBlue, the Social Network for Politics.`"
          :quote="blog.name"
          hashtags="crowdBlue,politics,political crowdfunding"
          twitter-user="crowdblue"
        ></cp-social-share-dialog>
      </div>
    </div>

    <cp-comments-post v-show="!forShare" :id="blog.id" :type="type" :setCount="setCommentsCount">
    </cp-comments-post>
  </div>
</template>

<style scoped>
div.social-feed-post-profile-wrapper {
  display: flex;
  flex-direction: row;
  margin-bottom: 1em;
}
div.social-feed-post-profile-wrapper .details-wrapper {
  display: flex;
  flex-direction: column;
  padding-left: 10px;
}

div.social-feed-post-profile-wrapper .profile-name {
  font-size: 1.3em;
  font-weight: 600;
  padding-bottom: 5px;
  padding-right: 5px;
  margin: 1px;
}

div.social-feed-post-profile-wrapper .post-time {
  color: #666;
  text-decoration: none;
  font-size: 0.9em;
  font-weight: 400;
}

img.social-feed-post-img {
  max-width: 100%;
  max-height: 100%;
  min-width: 100%;
}
span.social-feed-default-img {
  display: flex;
  align-items: center;
  justify-content: center;
}
a.social-feed-post-link {
  display: block;
  padding-top: 10px;
  font-size: 1.1em;
}

div.social-feed-post-wrapper {
  width: 100%;
  padding: 1.5em;
  border-bottom: 2px solid var(--neutral3);
  margin-bottom: 2.5em;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: auto;
}
div.social-feed-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.social-feed-post-wrapper > * {
  width: 100%;
}

.mini-recipient__subtitle {
  margin-top: 0px;
}

div.social-feed-box-wrapper.mobile img.social-feed-post-img {
  min-height: 45vh;
  object-fit: cover;
}
.social-feed-default-img {
  background: none;
}
div.social-feed-box-wrapper.mobile div.social-feed-post-wrapper {
  padding: 0.7em;
}
div.social-feed-post-img-placeholder {
  min-height: 400px;
  background: rgb(233, 94, 54);
  background: linear-gradient(180deg, rgba(233, 94, 54, 1) 65%, rgba(254, 130, 94, 1) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
header.social-feed-title-header {
  text-align: center;
  margin: 30px 0px;
}
div.social-feed-post-description {
  padding-top: 10px;
}
video.candidate-video-player {
  width: 100%;
  height: auto;
}
.profile-img.social-feed-default-img svg {
  margin-top: 10px;
}

.social-feed-sidebar {
  position: fixed;
}

.header-label {
  font-size: 16px;
  font-family: 'proxima-nova', Gotham, Helvetica, sans-serif;
  font-weight: 600;
  color: #121212;
}

.mobile-fixed-bottom-sidebar .social-feed-right-sidebar {
  padding: 15px;
  position: relative;
  max-width: 100% !important;
}

.small-desktop-right-sidebar .social-feed-right-sidebar {
  max-width: 12.2vh;
}

.small-desktop-right-sidebar .title-3 hr {
  display: none;
}

.mobile-fixed-bottom-sidebar {
  position: fixed;
  background: white;
  width: 100% !important;
  bottom: 0px;
  left: 0px;
  margin: 0px;
}
.search-results__tick_action {
  width: 50px;
  margin-right: auto;
}
.description {
  font-family: inherit;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 1.6;
  margin: 0px !important;
  padding-bottom: 5px;
  color: #000000;
}
.title {
  font-weight: bold;
  font-size: 25px;
  color: #000000;
  margin: 0px !important;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  max-width: 100%;
}
.image {
  border-radius: 5px;
  width: 100%;
  box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.2);
  margin: 0px 0px 0px 0px;
}
.video {
  border-radius: 5px;
  box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.2);
  max-width: 100%;
  height: auto;
  width: 100%;
}
.image-mobile {
  border-radius: 5px;
  max-height: 400px;
  max-width: 100%;
  width: auto;
  box-shadow: 1px 1px 6px rgba(0, 0, 0, 0.2);
  margin-top: 10px;
  object-fit: cover;
  object-position: center center;
}
</style>
